// Request/reply do skrytého Magic control iframu — Phoenix pošle akci s `requestId` a dostane odpověď
// (Magic handler odpoví `response.Send()` se stejným requestId). Promise-based, BEZ crashe (na rozdíl
// od `useLegacyMessaging`, který při chybě hodí výjimku přes error-boundary). Použití pro desktopové
// operace (debug stav/toggle, debug konzole, vyprázdnění keší, restart/kill).

import { getMagicDesktopFrame } from '@/shared/lib/legacyMagic';

const REQUEST_TIMEOUT_MS = 15000;

interface DesktopReply {
  readonly requestId?: string;
  readonly error?: string;
  readonly data?: Record<string, unknown>;
}

/**
 * Pošle `action` (+ `data`) do control iframu a resolvne odpovědí (`msg.data`), nebo rejectne při
 * `error` / timeoutu / nedostupném iframu.
 */
export function sendMagicDesktopRequest(
  action: string,
  data: Record<string, unknown> = {}
): Promise<Record<string, unknown>> {
  const frame = getMagicDesktopFrame();
  if (!frame) return Promise.reject(new Error('Magic desktop frame není dostupný'));

  const requestId = crypto.randomUUID();
  return new Promise((resolve, reject) => {
    const cleanup = () => {
      clearTimeout(timer);
      window.removeEventListener('message', handler);
    };
    const timer = setTimeout(() => {
      cleanup();
      reject(new Error('Magic neodpověděl včas'));
    }, REQUEST_TIMEOUT_MS);
    const handler = (event: MessageEvent) => {
      const msg = event.data as DesktopReply | null;
      if (!msg || msg.requestId !== requestId) return;
      cleanup();
      if (msg.error) reject(new Error(msg.error));
      else resolve(msg.data ?? {});
    };
    window.addEventListener('message', handler);
    frame.postMessage({ action, data, requestId }, '*');
  });
}
